import PropTypes from 'prop-types';
import React, { memo } from 'react';
import './section-header.scss';
import { ButtonSizes, ButtonTypes } from '../button';
import SearchInput from '../search-input';
import ButtonWrapper from './views/button-wrapper/button-wrapper';

/* eslint-disable react/jsx-props-no-spreading */
const SectionHeader = ({
  text, supportingText, buttons, showSearch, searchPlaceholder, onButtonClick, onSearchChange,
  showDivider, searchText, onSearchApply,
}) => {
  const getButtons = () => (
    <div className="section-header-buttons">
      {buttons.map((button) => (
        <ButtonWrapper {...button} onClick={onButtonClick} key={button.id} />
      ))}
    </div>
  );

  const getSearchInput = () => (
    <SearchInput
      value={searchText}
      onApply={onSearchApply}
      onChange={onSearchChange}
      placeholder={searchPlaceholder}
      className="section-header-search"
    />
  );

  const getDivider = () => <hr className="section-header-divider" />;

  return (
    <div className="section-header-cont">
      <div className="section-header-texts">
        {text && <div className="section-header-text">{text}</div>}
        {supportingText && (
          <div className="section-header-sup-text">{supportingText}</div>
        )}
      </div>
      <div className="section-header-tools">
        {getButtons()}
        {showSearch && getSearchInput()}
      </div>
      {showDivider && getDivider()}
    </div>
  );
};

SectionHeader.defaultProps = {
  supportingText: '',
  buttons: [],
  showSearch: false,
  searchPlaceholder: 'Search',
  showDivider: true,
  searchText: '',
  onSearchApply: () => {},
  onButtonClick: () => {},
  onSearchChange: () => {},
};

SectionHeader.propTypes = {
  text: PropTypes.string.isRequired,
  supportingText: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.oneOf(Object.values(ButtonTypes)),
    size: PropTypes.oneOf(Object.values(ButtonSizes)),
    icon: PropTypes.oneOfType([PropTypes.element,
      PropTypes.elementType, PropTypes.func, PropTypes.oneOf([null])]),
    disabled: PropTypes.bool,
  })),
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  showDivider: PropTypes.bool,
  searchText: PropTypes.string,
  onSearchApply: PropTypes.func,
  onButtonClick: PropTypes.func,
  onSearchChange: PropTypes.func,
};

export default memo(SectionHeader);
